import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { seedRandom } from '../../../break/BreakUtils';

registerCollisionAnimation('ORBITAL_SPIN', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  const particles = config.collisionEffectParticleCount || 20;
  for (let i = 0; i < particles; i++) {
    const rnd = seedRandom(e.id, i);
    const angleBase = rnd * Math.PI * 2;
    const rotation = progress * Math.PI * 4 * (i % 2 === 0 ? 1 : -1);
    const dist = (20 + rnd * 100) * progress;

    const x = e.pos.x + Math.cos(angleBase + rotation) * dist;
    const y = e.pos.y + Math.sin(angleBase + rotation) * dist;

    ctx.strokeStyle = determineColor(i, particles);
    ctx.globalAlpha = 1 - progress;
    ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(x, y);
    ctx.lineTo(x - Math.cos(angleBase + rotation) * 10, y - Math.sin(angleBase + rotation) * 10);
    ctx.stroke();
  }
});
